import React from 'react'
import iconPaste from '../svgs/icons.js'
import css_lib from '../lib/styles/css-lib'

export default function RGBW({ui_element_id, param_value, ui_element_svg_id}){
    
    let css_color = ''
    let fill_style = {}
        
    if (parseInt(param_value.bright) > 0) {
        css_color = css_lib.parseHueToRGB(param_value.hue, param_value.bright, param_value.saturation)
        fill_style = {fill: css_color, filter:'drop-shadow(0px 0px 2px #8884) drop-shadow(0px 0px 18px '+css_color+') drop-shadow(0px 0px 25px '+css_color+')'}
    }
    else fill_style = {filter: 'blur(1px)'}
   
    return(
        <div style={fill_style}>
            <div className={'icon'}>{iconPaste(ui_element_svg_id)}</div>
        </div>
    )
}